import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
// 角色权限管理功能已迁移至 admin 系统，移除冗余代码
// import permissionSlice from './slices/permissionSlice';
// import roleSlice from './slices/roleSlice';
// import userRoleSlice from './slices/userRoleSlice';

// 持久化配置
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'] // 只持久化auth状态
};

// 合并所有reducer
const rootReducer = combineReducers({
  auth: authSlice,
  ui: uiSlice,
  // 角色权限管理功能已迁移至 admin 系统
  // permission: permissionSlice,
  // role: roleSlice,
  // userRole: userRoleSlice,
});

// 创建持久化reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 配置store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;
